<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20 pt-15">
        <div class="bold9 size20 color1">
          竞价平台
          <!-- <span style="font-size: 14px; color: #ccd9e9"
            >Bidding Hall</span
          > -->
        </div>
        <div class="color-aaa color2" style="margin-top: 4px">
          共有{{ total }}条竞价
        </div>
      </div>
      <!-- 搜索条件 -->
      <div class="px-15 pt-25 border-box mb-20 bg-color">
        <el-form label-width="70px" class="flex between">
          <div class="flex">
            <el-form-item label="竞价标题:">
              <el-input
                v-model="queryInfo.title"
                style="width: 150px"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="参与方式:">
              <el-select
                v-model="queryInfo.participationMode"
                style="width: 100px; margin-right: 20px"
              >
                <el-option value="1" label="公开">公开</el-option>
                <el-option value="2" label="非公开">非公开</el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label-width="90px" label="报名截至时间：">
              <el-date-picker
                v-model="queryInfo.beginBeginTime"
                class="datePicker"
                style="width: 120px"
                type="date"
                placeholder="请选择"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label-width="90px" label="报名截至时间:">
              <el-date-picker
                @change="dateChange"
                v-model="dateRanger"
                class="datePicker"
                style="width: 220px"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发起单位:" class="ml-20">
              <el-input
                v-model="queryInfo.publishCompany"
                style="width: 150px"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-button
              @click="reset"
              class="buttonB"
              style="background-color: #95b3db"
              >重置</el-button
            >
            <el-button
              @click="getDaTingList"
              class="buttonB"
              style="background-color: #1c65c4"
              >搜索</el-button
            >
          </div>
        </el-form>
      </div>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{
          background: '#3B426C',
          color: '#ffffff',
          padding: '0px',
          height: '40px',
        }"
        :cell-style="{ padding: '0px' }"
        :row-style="{ height: '40px' }"
        class="mb-10"
        :data="tableData"
        stripe
        style="font-size: 14px"
      >
        <el-table-column prop="lie1" label="参与方式" align="center">
          <template slot-scope="scope">
            {{ scope.row.participationMode == 1 ? "公开" : "非公开" }}
          </template>
        </el-table-column>
        <el-divider direction="vertical"></el-divider>
        <el-table-column prop="sessionNum" label="竞价编号" align="center">
        </el-table-column>
        <el-table-column prop="title" label="竞价标题" align="center">
        </el-table-column>
        <el-table-column prop="publishCompany" label="发起单位" align="center">
        </el-table-column>
        <el-table-column prop="endTime" label="报名截至时间" align="center">
          <!-- <template>
            <div>距离报名结束还有<span style="color: #ff0053">5</span>天</div>
          </template> -->
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? "未开始" : "已开始" }}
          </template>
        </el-table-column>
        <el-table-column prop="lie6" label="操作" align="center">
          <template slot-scope="scope">
            <div v-if="userId">
              <div
                v-if="scope.row.status == 1"
                class="pointer"
                @click="goXuZhi(scope.row)"
              >
                未开始
              </div>
              <div v-else class="pointer" @click="goXuZhi(scope.row)">
                我要竞价
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        style="padding: 17px 50px 17px 0px"
        class="bg-color border-box"
      >
        <el-pagination
          class="pagination flex flex-end"
          prev-text="上一页"
          next-text="下一页"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          layout="prev,pager, next,slot"
          :total="total"
        >
          <div style="color: #ccd9e9; margin-left: 160px">
            到第
            <el-input
              v-model="queryInfo.pageNum"
              oninput="value=value.replace(/[^\d.]/g,'')"
            ></el-input
            >页/共{{ Math.ceil(total / queryInfo.pageSize) }}页
          </div>
          <div class="btn" @click="getDaTingList">确定</div>
        </el-pagination>
      </div>
    </div>
    <Footer class="mt-15" />
    <Result
      :title="resultTitle"
      :SubTitle="subTitle1"
      :isShow="resultShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Result from "../components/Result.vue";

export default {
  components: {
    Footer,
    Result,
  },
  data() {
    return {
      resultTitle: "",
      subTitle1: "",
      resultShow: false,
      //表单数据
      queryInfo: {
        title: null,
        publishCompany: null, //发布单位
        participationMode: null, //参与方式
        beginBeginTime: null, //截止时间
        pageNum: 1,
        pageSize: 10,
        endBeginTime: null,
      },
      message: "",
      //表格数据
      tableData: [],
      total: 0,
      userId: window.sessionStorage.getItem("userId"),
      dateRanger: "",
    };
  },
  mounted() {
    this.getDaTingList();
  },
  methods: {
    resultClose() {
      this.resultShow = false;
    },
    dateChange(val) {
      this.queryInfo.beginBeginTime = val[0];
      this.queryInfo.endBeginTime = val[1];
    },
    //获取竞价大厅列表
    async getDaTingList() {
      this.queryInfo.pageNum = Number(this.queryInfo.pageNum);
      let userId = window.sessionStorage.getItem("userId");
      // let url = "";
      // if (!userId) {
      //   userId = "";
      //   url = "/api/biddingInfo/getBiddingHallList/";
      // } else {
      //   url = `/api/biddingInfo/getBiddingHallList/${userId}`;
      // }
      const { data: res } = await this.$axios({
        url: `/api/biddingInfo/getBiddingHallList/${userId}`,
        method: "get",
        params: {
          beginBeginTime: this.queryInfo.beginBeginTime,
          endBeginTime: this.queryInfo.endBeginTime,
          title: this.queryInfo.title,
          publishCompany: this.queryInfo.publishCompany,
          participationMode: this.queryInfo.participationMode,
          pageNum: this.queryInfo.pageNum,
          pageSize: this.queryInfo.pageSize,
        },
      });
      if (res.code == 200) {
        this.tableData = res.rows;
        this.total = res.total;
      } else {
        console.log(res.msg);

        return;
      }
    },
    //重置
    reset() {
      this.queryInfo = {
        title: null,
        publishCompany: null, //发布单位
        participationMode: null, //参与方式
        beginBeginTime: null, //截止时间
        pageNum: 1,
        pageSize: 10,
        endBeginTime: null,
      };
      this.dateRanger = "";
      this.getDaTingList();
    },
    //搜索
    search() {},

    //点击我要竞价跳转须知页面
    goXuZhi(row) {
      if (window.sessionStorage.getItem("userId")) {
        window.sessionStorage.setItem("jjId", row.id);
        this.$router.push({
          path: "/jjlbxq",
        });
      } else {
        this.resultTitle = "请先登录";
        this.subTitle1 = "";
        this.resultShow = true;
        return;
      }
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val;
      this.getDaTingList();
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}
/deep/.el-date-editor .el-range__icon {
  display: none;
}
/deep/.el-date-editor .el-range__close-icon {
  display: none;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-table__empty-text {
  line-height: 300px;
}

.weikaishi {
  font-size: 14px;
  font-weight: bold;
  color: #95b3db;
}
.jingjia {
  font-size: 14px;
  font-weight: bold;
  color: #ff9200;
}

//隔行变色的背景色
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f3f6fb !important;
}
//表头内边距
/deep/.el-table__header tr.el-table__header th {
  padding: 0 !important;
}
//表格内边距
/deep/.el-table__body tr.el-table__body td {
  padding: 0 !important;
}
//表头单元格右边框
/deep/.el-table th.el-table__cell > .cell {
  border-right: 1px solid #fff;
}
//表格单元格右边框
/deep/.el-table__cell > .cell {
  border-right: 1px solid #95b3db;
}
//取消表头单元格最后一列右边框
/deep/.el-table th.el-table__cell:nth-child(6) > .cell {
  border-right: none;
}
//最后一列不要右边框
/deep/.el-table__cell:last-of-type > .cell {
  border-right: none;
}
//表格下边框
/deep/.el-table td.el-table__cell {
  border-bottom: none;
}
//表单输入框前的文字
/deep/.el-form-item__label {
  padding: 0 !important;
  font-size: 12px !important;
  font-weight: bold;
  color: #3b426b !important;
}
//表单输入框右边距
/deep/.el-input {
  margin-right: 30px !important;
}
//表单输入框内部样式
/deep/.el-input__inner {
  padding: 0 !important;
  height: 30px !important;
  border-radius: 10px !important;
  padding-left: 9px !important;
  border: 1px solid #95b3db !important;
  &::placeholder {
    font-size: 14px !important;
  }
}
//报名时间输入框右侧图标
/deep/.el-icon-date:before {
  content: "\e790";
  color: #95b3db;
  margin-left: 90px;
}
//参与方式输入框右侧图标
/deep/.el-icon-arrow-up:before {
  content: "\e78f";
  color: #95b3db;
}
//重置与搜索按钮样式
.buttonB {
  width: 60px !important;
  height: 30px !important;
  font-size: 14px !important;
  color: #fff !important;
  border-radius: 10px !important;
  padding: 0 !important;
  margin-top: 5px !important;
  line-height: 30px !important;
}
//分页上一页下一页的样式
/deep/.pagination.el-pagination span {
  width: 80px;
  height: 30px;
  border: 1px solid #1c65c4;
  border-radius: 25px;
  color: #3b426b;
  font-weight: bold;
  font-size: 14px;
}
//分页页码颜色
/deep/.pagination.el-pagination li {
  color: #ccd9e9;
}
//分页页码选中之后的颜色
/deep/.pagination.el-pagination li.active {
  color: #3b426b;
}
//分页到第几页输入框右边距
/deep/.el-pagination .el-input {
  margin-right: 0 !important;
  width: 35px;
}
//分页到第几页输入框样式
/deep/.el-pagination .el-input__inner {
  width: 35px;
  height: 30px;
  border: 1px solid #ccd9e9;
  border-radius: 8px;
  padding-left: 0 !important;
}
//确定按钮
.btn {
  width: 80px;
  height: 30px;
  border-radius: 25px;
  background-color: #1c65c4;
  color: #fff;
  text-align: center;
  line-height: 30px;
  margin-left: 24px;
  cursor: pointer;
}
</style>